import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { useIsSingleColumn } from '../../../controllers/layout';

type LeftAsideProps = {
	children: React.ReactNode;
};

const style = cssMap({
	root: {
		paddingTop: token('space.250'),
		paddingBottom: token('space.250'),
		paddingLeft: token('space.250'),
		paddingRight: token('space.250'),
		justifyContent: 'start',
		width: '320px',
		minWidth: '320px',
	},
	rootFullWidth: {
		width: '100%',
	},
});
export const LeftAside = ({ children }: LeftAsideProps) => {
	const isSingleColumn = useIsSingleColumn();

	return (
		<>
			<Stack space="space.400" xcss={cx(style.root, isSingleColumn && style.rootFullWidth)}>
				{children}
			</Stack>
		</>
	);
};
